export const getUserName = state => state.authSlice.user;
export const getToken = state => state.authSlice.token;
export const getIsLoggedIn = state => state.authSlice.isLoggedIn;
export const getLoadingRefresh = state => state.authSlice.isFetchingCurrentUser;
